import { createHistory, useBasename } from 'history';

export const history = useBasename(createHistory)({
  basename: window.AdaptiveLight.config.baseUrl || '/'
});
